// Charge (UA) : comparaison entre une seance posee avec son modele et son corps seul.

/** Ecart signe entre l'UA avec modele et l'UA du corps seul, ex: "+28". */
export function ecartUA(avecModele: number, corps: number | null): string {
  const ecart = Math.round(avecModele) - (corps ?? 0);
  return (ecart > 0 ? '+' : '') + ecart;
}
